export const menuCategories = [
  { id: "all", name: "All Items", icon: "IceCream" },
  { id: "ice-cream", name: "Ice Cream", icon: "IceCream" },
  { id: "milkshakes", name: "Milkshakes", icon: "GlassWater" },
  { id: "faluda", name: "Faluda", icon: "Sparkles" },
  { id: "rabdi", name: "Rabdi", icon: "Flame" },
  { id: "extras", name: "Extras & Cones", icon: "PlusCircle" },
];

export const staticMenuItems = [
  {
    id: "prod-1",
    name: "Kesar Pista",
    category: "ice-cream",
    categoryName: "Ice Cream",
    price: 60,
    description: "Premium Kashmiri saffron infused with roasted pistachio nuts in rich natural cream.",
    image: "https://images.unsplash.com/photo-1560008581-09826d1de69e?w=600&auto=format&fit=crop&q=80",
    badge: "Bestseller",
    isSeasonal: false,
    isPopular: true,
  },
  {
    id: "prod-2",
    name: "Mango Scoop",
    category: "ice-cream",
    categoryName: "Ice Cream",
    price: 50,
    description: "Handcrafted using 100% real ripe seasonal mango pulp and fresh dairy milk.",
    image: "https://images.unsplash.com/photo-1501443762994-82bd5dace89a?w=600&auto=format&fit=crop&q=80",
    badge: "Seasonal Special",
    isSeasonal: true,
    isPopular: true,
  },
  {
    id: "prod-3",
    name: "Butterscotch",
    category: "ice-cream",
    categoryName: "Ice Cream",
    price: 50,
    description: "Creamy caramel butterscotch delight with crunchy brown sugar praline bits.",
    image: "https://images.unsplash.com/photo-1497034825429-c343d7c6a68f?w=600&auto=format&fit=crop&q=80",
    badge: "Crowd Favourite",
    isSeasonal: false,
    isPopular: true,
  },
  {
    id: "prod-4",
    name: "Chocolate Scoop",
    category: "ice-cream",
    categoryName: "Ice Cream",
    price: 45,
    description: "Rich dark cocoa blended into velvety smooth cream for true chocolate lovers.",
    image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=600&auto=format&fit=crop&q=80",
    badge: "Classic",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-5",
    name: "Strawberry Scoop",
    category: "ice-cream",
    categoryName: "Ice Cream",
    price: 45,
    description: "Pure farm-fresh strawberries crushed with milk, delivering a naturally fruity tang.",
    image: "https://images.unsplash.com/photo-1633933358116-a27b902fad35?w=600&auto=format&fit=crop&q=80",
    badge: "Real Fruit",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-6",
    name: "Vanilla Scoop",
    category: "ice-cream",
    categoryName: "Ice Cream",
    price: 40,
    description: "Pure natural vanilla bean pods blended into creamy whole milk for a timeless taste.",
    image: "https://images.unsplash.com/photo-1570197788417-0e82375c9371?w=600&auto=format&fit=crop&q=80",
    badge: "Signature",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-7",
    name: "Oreo Shake",
    category: "milkshakes",
    categoryName: "Milkshakes",
    price: 90,
    description: "Thick cookies and cream shake with real crunchy Oreo chunks and natural vanilla.",
    image: "https://images.unsplash.com/photo-1541658016709-82535e94bc69?w=600&auto=format&fit=crop&q=80",
    badge: "Must Try",
    isSeasonal: false,
    isPopular: true,
  },
  {
    id: "prod-8",
    name: "Chocolate Shake",
    category: "milkshakes",
    categoryName: "Milkshakes",
    price: 80,
    description: "Decadent thick chocolate milkshake made with real ice cream and chocolate drizzle.",
    image: "https://images.unsplash.com/photo-1572490122747-3968b75cc699?w=600&auto=format&fit=crop&q=80",
    badge: "Popular",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-9",
    name: "Strawberry Shake",
    category: "milkshakes",
    categoryName: "Milkshakes",
    price: 80,
    description: "Creamy refreshing strawberry shake prepared with fresh fruit crush and full cream milk.",
    image: "https://images.unsplash.com/photo-1579954115545-a95591f28bfc?w=600&auto=format&fit=crop&q=80",
    badge: "Refreshing",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-10",
    name: "Vanilla Shake",
    category: "milkshakes",
    categoryName: "Milkshakes",
    price: 70,
    description: "Classic thick and frothy vanilla milkshake whipped to perfection.",
    image: "https://images.unsplash.com/photo-1568901839119-631418a3910d?w=600&auto=format&fit=crop&q=80",
    badge: "Classic",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-11",
    name: "Kesar Faluda",
    category: "faluda",
    categoryName: "Faluda",
    price: 120,
    description: "Authentic Udaipur style saffron falooda with sabja seeds, vermicelli, and Kesar scoop.",
    image: "https://images.unsplash.com/photo-1605112013730-7b6cc0c5a0b6?w=600&auto=format&fit=crop&q=80",
    badge: "Royal Special",
    isSeasonal: false,
    isPopular: true,
  },
  {
    id: "prod-12",
    name: "Royal Faluda",
    category: "faluda",
    categoryName: "Faluda",
    price: 100,
    description: "Traditional rose syrup falooda with tender vermicelli, basil seeds, rabdi, and ice cream.",
    image: "https://images.unsplash.com/photo-1505394033641-40c6ad1178d7?w=600&auto=format&fit=crop&q=80",
    badge: "House Special",
    isSeasonal: false,
    isPopular: true,
  },
  {
    id: "prod-13",
    name: "Plain Rabdi",
    category: "rabdi",
    categoryName: "Rabdi",
    price: 60,
    description: "Slow-simmered traditional sweet rabdi with cardamom, saffron, and malai layers.",
    image: "https://images.unsplash.com/photo-1571115764595-644a1f56a55c?w=600&auto=format&fit=crop&q=80",
    badge: "Traditional",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-14",
    name: "Rabdi with Ice Cream",
    category: "rabdi",
    categoryName: "Rabdi",
    price: 90,
    description: "Warm, rich malai rabdi paired with a cold scoop of artisanal natural vanilla ice cream.",
    image: "https://images.unsplash.com/photo-1488900128323-21503983a07e?w=600&auto=format&fit=crop&q=80",
    badge: "Chef's Signature",
    isSeasonal: false,
    isPopular: true,
  },
  {
    id: "prod-15",
    name: "Waffle Cone",
    category: "extras",
    categoryName: "Extras & Cones",
    price: 15,
    description: "Freshly baked crispy golden waffle cone made in-house.",
    image: "https://images.unsplash.com/photo-1551024506-0bccd828d307?w=600&auto=format&fit=crop&q=80",
    badge: "Crispy",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-16",
    name: "Chocolate Sauce",
    category: "extras",
    categoryName: "Extras & Cones",
    price: 20,
    description: "Warm molten chocolate fudge drizzle topping for your scoop.",
    image: "https://images.unsplash.com/photo-1606312619070-d48b4c652a52?w=600&auto=format&fit=crop&q=80",
    badge: "Topping",
    isSeasonal: false,
    isPopular: false,
  },
  {
    id: "prod-17",
    name: "Rainbow Sprinkles",
    category: "extras",
    categoryName: "Extras & Cones",
    price: 10,
    description: "Crunchy colorful sugar sprinkles topping for children and dessert lovers.",
    image: "https://images.unsplash.com/photo-1563805042-7684c019e1cb?w=600&auto=format&fit=crop&q=80",
    badge: "Fun",
    isSeasonal: false,
    isPopular: false,
  },
];
